<div
  [formGroup]="formGroup!"
  [class]="config?.cssClass ? 'mb-4 ' + config!.cssClass : 'form-group'"
>
  <label
    for="{{ config?.name }}"
    class="mb-1 fw-bold"
  >
    {{ config?.label }}
    @if (config ? showAsterisk(config) : false) {
      *
    }
    @if (config?.additionalText) {
      <span class="ms-3 small">{{ config!.additionalText }}</span>
    }
  </label>

  <textarea
    class="form-control"
    [ngClass]="{ 'is-valid': valid, 'is-invalid': invalid }"
    [formControlName]="config?.name ?? null"
    [id]="config?.name"
    [attr.rows]="config?.rows ?? null"
    [attr.aria-describedby]="config?.name + 'err'"
  ></textarea>

  <div
    libFormFieldError
    [fieldConfig]="config!"
    [formComponent]="fc"
  ></div>
</div>
